<template>
	<div class="row">
		<div class="col-sm-11 rounded-10 py-4 mx-auto">
			<BreadCrumb name="Sight" />
			<SightTable v-if="masterStore.state.activeComponent === 'table'" />
			<SightCreate v-if="masterStore.state.activeComponent === 'create'" />
			<SightEdit v-if="masterStore.state.activeComponent === 'edit'" />
		</div>
	</div>
</template>
<script>
	import { inject, onBeforeUnmount, watch } from "vue";
	import API from "@/config/api";
	import toast from "@/config/toast";

	import SightCreate from "@/components/SightCreate";
	import SightTable from "@/components/SightTable";
	import SightEdit from "@/components/SightEdit";
	import BreadCrumb from "@/partials/MasterBreadCrumb";

	export default {
		name: "Sight",
		components: {
			SightCreate,
			SightTable,
			SightEdit,
			BreadCrumb,
		},

		setup: () => {
			const masterStore = inject("masterStore", masterStore);

			const deleteData = async (id) => {
				try {
					const response = await API.privateRequest.delete(
						`/sights/${masterStore.state.deleteId}`,
					);
					toast.success(
						{ message: "Sight Removed!", position: "topRight" },
						true,
					);
					const newStoreData = masterStore.state.data.filter(
						(item) => item._id !== id,
					);
					masterStore.methods.changeData(newStoreData);
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
				}
			};
			watch(
				() => masterStore.state.deleteId,
				(newDeleteId, previousDeleteId) => {
					if (!newDeleteId) return;
					deleteData(newDeleteId);
					masterStore.methods.setId("delete", previousDeleteId);
				},
			);
			onBeforeUnmount(masterStore.methods.destroy());

			return {
				deleteData,
				masterStore,
			};
		},
	};
</script>
